import React from 'react';

export const Plan = ({ className, color = '#2C313A' }) => {
  return (
    <svg
      className={`plan ${className}`}
      fill="none"
      height="20"
      viewBox="0 0 20 20"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="plan">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 3.75C2.5 3.05964 3.05964 2.5 3.75 2.5H16.25C16.9404 2.5 17.5 3.05964 17.5 3.75V16.25C17.5 16.9404 16.9404 17.5 16.25 17.5H3.75C3.05964 17.5 2.5 16.9404 2.5 16.25V13.3854C2.5 13.0402 2.77982 12.7604 3.125 12.7604C3.47018 12.7604 3.75 13.0402 3.75 13.3854V16.25H16.25V12.2917H10.625V13.3854C10.625 13.7306 10.3452 14.0104 10 14.0104C9.65482 14.0104 9.375 13.7306 9.375 13.3854V9.94792C9.375 9.60274 9.65482 9.32292 10 9.32292C10.3452 9.32292 10.625 9.60274 10.625 9.94792V11.0417H16.25V3.75H10.625V6.51042C10.625 6.85559 10.3452 7.13542 10 7.13542C9.65482 7.13542 9.375 6.85559 9.375 6.51042V3.75H3.75V9.94792C3.75 10.2931 3.47018 10.5729 3.125 10.5729C2.77982 10.5729 2.5 10.2931 2.5 9.94792V3.75Z"
          fill={color}
          fillOpacity="0.4"
        />
      </g>
    </svg>
  );
};
